import React from 'react'
import { Box } from '@mui/material'
import { EmtTypography, EmtIcon, EmtAvatar, EmtLoader } from 'emt-components-v2'
import { Routes } from '@/assets/configs'
import useIsResponsive from '@/hooks/useIsResponsive'

interface PetsitterAvatarProps {
  uuid: string
  name: string
  mainPicture?: {
    imageThumbnailUrl?: string
  }
  isEditing?: boolean
  isLoading?: boolean
  onRemove?: (uuid: string) => void
  hasService?: boolean
  onOpenProfile?: () => void
}

export const PetsitterAvatar: React.FC<PetsitterAvatarProps> = ({
  uuid,
  name,
  mainPicture,
  isEditing,
  isLoading,
  onRemove,
  hasService = true,
  onOpenProfile,
}) => {
  const [isMobile] = useIsResponsive()
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '6px',
          maxWidth: '44px',
        }}
      >
        <Box
          sx={{
            border: hasService ? '2px solid #AE59C6' : '1px solid #C7C5C9',
            borderRadius: '12px',
            position: 'relative',
            cursor: 'pointer',
          }}
          onClick={() =>
            isEditing
              ? onRemove?.(uuid)
              : isMobile
              ? onOpenProfile?.()
              : window.open(Routes.ProfilePetSitter(uuid || ''), '_blank')
          }
        >
          <EmtAvatar
            size="medium"
            variant="rounded"
            src={mainPicture?.imageThumbnailUrl}
            sx={{
              width: '44px',
              height: '44px',
              borderRadius: '12px',
              border: '1px solid #F9F9F9',
              filter: !hasService ? 'grayscale(1)' : 'none',
              opacity: !hasService ? 0.5 : 1,
            }}
          />
          {isEditing && (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: !hasService ? 'transparent' : '#F7E2FEE5',
                opacity: 0.9,
                borderRadius: '10px',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {isLoading ? (
                <EmtLoader
                  size={22}
                  // @ts-expect-error
                  color="purple"
                />
              ) : (
                <EmtIcon className="emt-bin" sx={{ color: 'purple.main', fontSize: '17px' }} />
              )}
            </Box>
          )}
        </Box>
        <EmtTypography
          variant="body1"
          sx={{
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: '1',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            maxWidth: '100%',
            opacity: isEditing ? 0.5 : !hasService ? 0.5 : 1,
            filter: !hasService ? 'grayscale(1)' : 'none',
            marginTop: !hasService ? '2px' : '0',
          }}
        >
          {name}
        </EmtTypography>
      </Box>
    </>
  )
}
